const $ = require('jquery');
require('bootstrap');
const i18next = require('i18next');
require('datatables.net-select-bs4')( window, $ );

const datatablesGermanLanguage = require('../lang/datatables.de.lang');

const constants = require('../data/constants');

class Ui {
  static translateElements() {
    $('[data-translation-key]').each(function () {
      $(this).html(i18next.t($(this).data('translation-key')));
    });

    $('[data-title-translation-key]').each(function () {
      $(this).data('translation-title', i18next.t($(this).data('title-translation-key')));
    });

    $('[data-placeholder-translation-key]').each(function () {
      $(this).attr('placeholder', i18next.t($(this).data('placeholder-translation-key')));
    });

    $('[data-href-translation-key]').each(function () {
      $(this).attr('href', i18next.t($(this).data('href-translation-key')));
    });

    $('.download-manual').attr('href', 'downloads/'+i18next.languages[0]+'/Detour_Editor_User_manual.pdf');

    if(i18next.languages[0] === 'en') {
      $('#linkLegal').attr("href", "https://www.maptrip.de/en/legal/");
      $('#linkHomepage').attr("href", "https://www.maptrip.de/en/gps-for-truckers/");
    } else {
      $('#linkLegal').attr("href", "https://www.infoware.de/impressum/");
      $('#linkHomepage').attr("href", "https://www.maptrip.de/");
    }
  }

  /**
   * Shows a modal with the error message
   *
   * @param {string} error
   */
  static showModalError(error) {
    const modal = $('#modalError');
    modal.find('#js-error-popup').html(error);
    modal.modal('show');
  }

  /**
   * Shows a modal with a success message
   *
   * @param {string} message
   */
  static showModalSuccess(message) {
    const modal = $('#modalSuccess');
    modal.find('#modalSuccessBody').html(message);
    modal.modal('show');
  }

  static setLoggedInUser(username) {
    $('#js-username').html(i18next.t('general.logged-in-as', { username }));
  }

  /**
   *
   * @param {Files} files
   * @param {Localization} localization
   */
  static updateFileList(files, localization) {
    return new Promise((resolve, reject) => {
      $(document).ready(() => {
        const fileTableElement = $('#fileList');
        try {
          $('#modalFileListTitle').html(localization.translate('editor.titles.your-files', { total: files.count }));

          const rows = [];

          let languageObject = null;

          switch (localization.currentLanguage) {
            case 'de':
              languageObject = datatablesGermanLanguage;
              break;
            case 'en':
            default:
              languageObject = null;
          }

          const fileTable = fileTableElement.DataTable({
            destroy: true,
            language: languageObject,
            data: files.getList(),
            columns: [
              {
                title: localization.translate('general.active'),
                defaultContent: '',
                className: 'select-checkbox',
                orderable: false
              },
              {
                title: localization.translate('general.id'),
                data: "id"
              },
              {
                title: localization.translate('general.name'),
                data: "name"
              },
              {
                title: localization.translate('general.version'),
                data: "version"
              },
              {
                title: localization.translate('general.actions'),
                mRender: (data, type, row) => {
                  const buttonsRaw = Ui.getButtonsForFile(row.id);
                  let buttons = '<div class="table-actions">';

                  buttonsRaw.forEach((item) => {
                    buttons += item[0].outerHTML;
                  });

                  buttons += '</div>';
                  return buttons;
                },
              },
            ],
            order: [ 1, 'desc' ],
            select: {
              style: 'os',
              selector: 'td:first-child'
            },
            createdRow: (row, data, index) => {
              rows.push({ index, row, data });
            },
          });

          resolve({fileTableElement, fileTable, rows});
        } catch (e) {
          reject(e);
        }
      });
    });
  }

  static updateFile(file) {
    $('.track-name-panel').html(file.name);
  }

  /**
   *
   * @param {Number} unsaved
   */
  static updateSaveBadge(unsaved) {
    const badge = $('.test-mode > .custom-badge');

    if (unsaved === 0) {
      badge.addClass('d-none');
    } else {
      badge.removeClass('d-none').html(unsaved.toString());
    }
  }

  static showModalConfirmation(question, confirmationButtonText, confirmationCallback) {
    const modal = $('.modalConfirmation');
    const confirmButton = modal.find('#modalConfirmationConfirm');
    confirmButton.html(confirmationButtonText);

    // noinspection JSUnresolvedFunction
    confirmButton.off('click');

    // noinspection JSDeprecatedSymbols
    confirmButton.on('click', () => {
      modal.modal('hide');
      confirmationCallback();
    });

    modal.find('.modal-body > p').html(question);

    modal.modal('show');
  }

  static showFileListHeader() {
    $('.content-editor').removeClass('mode-editing').addClass('mode-normal');
    $('.button-mode-normal').removeClass('d-none');
    $('.button-mode-editing').addClass('d-none');
  }

  static showFileEditHeader() {
    $('.content-editor').removeClass('mode-normal').addClass('mode-editing');
    $('.button-mode-normal').addClass('d-none');
    $('.button-mode-editing').removeClass('d-none');
  }

  static addListeners(caller) {
    // noinspection JSDeprecatedSymbols
    $(document).on('click', () => {
      $('.editor-context-menu').hide();
    });

    $(() => {
      $(document).on('hidden.bs.modal', '.modal-create-file', () => {
        $('#createFileFormName').val('');
        $('#createFileFormSubmit').prop('disabled', true);
      });

      // noinspection JSDeprecatedSymbols
      $('#createFileFormName').on('input', (event) => {
        const currentValue = $(event.target).val();
        const submitButton = $('#createFileFormSubmit');

        if (Ui.validateFileName(currentValue)) {
          submitButton.prop('disabled', false);
        } else {
          submitButton.prop('disabled', true);
        }
      });

      // noinspection JSDeprecatedSymbols
      $('#createFileFormSubmit').on('click', () => {
        $('#createFileForm').trigger('submit');
      });

      // noinspection JSDeprecatedSymbols
      $('#createFileForm').on('submit', (event) => {
        const name = $('#createFileFormName').val();

        if (Ui.validateFileName(name)) {
          caller.createFile(name);
        } else {
          Ui.showModalError(i18next.t('errors.please-add-a-file-name'));
        }

        event.preventDefault();
      });

      $('[data-toggle="tooltip"]').tooltip({
        title() {
          return $(this).data('translation-title');
        },
      });
    });

    $('#modalError').on('shown.bs.modal', () => {
      $('#btnModalErrorClose').trigger('focus');
    });
  }

  static validateFileName(name) {
    if (name.length < 2 || name.length > 50) {
      return false;
    }

    return name.match(/^[a-zA-Z0-9äöüßÄÖÜ]*$/g) !== null;
  }

  /**
   * @param {string|html} key
   */
  static showInfoBar(key) {
    const infoBarContainer = $('.ctrl-info');
    const infoBar = $('.info-text');

    infoBar.html(i18next.t(key))
      .data("translation-key", key)
      .attr("data-translation-key", key);

    infoBarContainer.removeClass('d-none');
  }

  static hideInfoBar() {
    $('.ctrl-info').addClass('d-none');
  }

  /**
   * @param segmentsRaw
   * @param {Localization} localization
   * @return {Promise<any>}
   */
  static updateSegmentList(segmentsRaw, localization, currentPage) {
    // deep copy the segments so we're sure they're not tampered with
    // and the assumptions in the code below are certain
    let segments = $.extend(true, [], segmentsRaw);

    return new Promise((resolve, reject) => {
      try {
        $('#modalSegmentListTitleListTitle').html(localization.translate('editor.titles.your-files', { total: segments.length }));
        const directionMap = {
          1: '&rarr;',
          2: '&larr;',
          3: '&harr;',
        };

        const rows = [];

        segments = segments.filter(segment => segment._attributes.SegmentType !== constants.SEGMENT_TYPE_DELETED_ORIGINAL || segment._attributes.detourEditor_deletedByUser);

        const data = segments.map((segment) => {
          return Ui.getSegmentListRow(segment, localization, directionMap);
        });

        let languageObject = null;

        switch (localization.currentLanguage) {
          case 'de':
            languageObject = datatablesGermanLanguage;
            break;
          case 'en':
          default:
            languageObject = null;
        }

        window.dataTable = $('#segmentList').DataTable({
          destroy: true,
          data,
          language: languageObject,
          order: [[0, 'asc'], [2, 'desc']],
          rowId: function(row) {
            return 'segmentList_' + row[12];
          },
          columns: [
            { title: 'status-code' },
            { title: localization.translate('general.status') },
            { title: localization.translate('general.id') },
            { title: localization.translate('general.name') },
            { title: localization.translate('general.type') },
            { title: localization.translate('general.direction') },
            { title: localization.translate('general.begin-datetime') },
            { title: localization.translate('general.end-datetime') },
            { title: localization.translate('general.date-created') },
            { title: localization.translate('general.date-modified') },
            { title: localization.translate('general.modified-by') },
            {
              title: localization.translate('general.actions'),
              mRender: (buttonsRaw) => {
                let buttons = '<div class="table-actions">';

                buttonsRaw.forEach((item) => {
                  buttons += item[0].outerHTML;
                });

                buttons += '</div>';
                return buttons;
              },
            },
          ],
          columnDefs: [
            {
              targets: [0],
              visible: false,
              searchable: false,
            },
          ],
          createdRow: (row, rowData, index) => {
            rows.push({ row, rowData, segment: segments[index] });
          },
        });
        resolve(rows);
      } catch (e) {
        reject(e);
      }
    });
  }

  static getButtonsForSegment(segment) {

    const segmentCategory = constants.SEGMENT_TYPE_TO_CATEGORY[segment.type];

    const buttonZoom = $(`<button id="btn-segment-zoom" class="btn btn-info" rel="${segment.hash}">`).append('<i class="fas fa-search-plus"></i>');
    const buttonSave = $(`<button id="btn-segment-save" class="btn btn-success" rel="${segment.hash}" data-segmenttype="${segmentCategory}">`).append('<i class="fas fa-save"></i>');
    const buttonEdit = $(`<button id="btn-segment-edit" class="btn btn-warning" rel="${segment.hash}" data-segmenttype="${segmentCategory}">`).append('<i class="far fa-edit"></i>');
    const buttonDelete = $(`<button id="btn-segment-delete" class="btn btn-danger" rel="${segment.hash}" data-segmenttype="${segmentCategory}">`).append('<i class="far fa-trash-alt"></i>');
    const buttonUndo = $(`<button id="btn-segment-undo" class="btn btn-warning" rel="${segment.hash}" data-segmenttype="${segmentCategory}">`).append('<i class="fas fa-undo"></i>');

    switch (segment.flag) {
      case constants.SEGMENT_PUBLISHED:
      default:
        if(segment.type === constants.SEGMENT_TURN_RESTRICTION) {
          return [buttonZoom, buttonDelete];
        } else if(segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
          return [buttonZoom, buttonEdit];
        } else {
          return [buttonZoom, buttonEdit, buttonDelete];
        }
      case constants.SEGMENT_NEW:
        if(segment.type === constants.SEGMENT_TURN_RESTRICTION) {
          return [buttonSave, buttonZoom, buttonDelete];
        } else if(segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
          return [buttonSave, buttonZoom, buttonEdit];
        } else {
          return [buttonSave, buttonZoom, buttonEdit, buttonDelete];
        }
      case constants.SEGMENT_EDITED:
        if(segment.type === constants.SEGMENT_TURN_RESTRICTION) {
          return [buttonSave, buttonZoom, buttonDelete];
        } else if(segment.type === constants.SEGMENT_TYPE_DIVIDED_STREET || segment.type === constants.SEGMENT_TYPE_DISSECTED_STREET) {
          return [buttonSave, buttonZoom, buttonEdit];
        } else {
          return [buttonSave, buttonZoom, buttonEdit, buttonDelete];
        }
      case constants.SEGMENT_DELETED:
        return [buttonSave, buttonUndo];
    }
  }

  static getButtonsForFile(fileId) {
    const buttonLoad = $(`<button id="btn-file-load" class="btn btn-success" rel="${fileId}">`).append('<i class="far fa-edit"></i>');
    const buttonDelete = $(`<button id="btn-file-delete" class="btn btn-danger" rel="${fileId}">`).append('<i class="far fa-trash-alt"></i>');

    return [buttonLoad, buttonDelete];
  }

  static getSegmentListRow(segment, localization, directionMap) {
    let name = segment.getAttributeByName('description');
    const direction = segment.getAttributeByName('direction');
    const startRaw = segment.getAttributeByName('start') ? segment.getAttributeByName('start') : segment.getAttributeByName('detourEditor_start');
    const endRaw = segment.getAttributeByName('end') ? segment.getAttributeByName('end') : segment.getAttributeByName('detourEditor_end');
    let createdRaw;
    let modifiedRaw;

    if(segment.hasOwnProperty.call(segment._attributes, 'created')) {
      createdRaw = segment.getAttributeByName('created');
    } else {
      createdRaw = segment.getAttributeByName('detourEditor_created');
    }

    if(segment.hasOwnProperty.call(segment._attributes, 'modified')) {
      modifiedRaw = segment.getAttributeByName('modified');
    } else {
      modifiedRaw = segment.getAttributeByName('detourEditor_modified')
    }

    if(!name) {
      name = segment.getAttributeByName('detourEditor_description');
    }

    let start;
    let end;
    let created;
    let modified;
    let modifiedBy = segment.getAttributeByName('detourEditor_modifiedBy');

    if (startRaw && startRaw !== '') {

      /*
       original code:
          start = new Date(startRaw.replace('Z', '+01:00')
       reason for change:
          The date got shifted one hour to create the dateString in the segment-table. This caused the date to be displayed different than the date the user entered.
          The reason why the startDate gets shifted, but the endDate does not is not know anymore. If something breaks, replace the new code with the original.
       */
      start = new Date(startRaw);
      start = Ui.formatDate(start, localization);
      /*
      start = start.toLocaleDateString(
        localization.translate('general.locale'),
        constants.LOCALE_FORMAT_OPTIONS,
      );*/
    }

    if (endRaw && endRaw !== '') {
      end = new Date(endRaw);
      end = Ui.formatDate(end, localization);
      /*
      end = end.toLocaleDateString(
        localization.translate('general.locale'),
        constants.LOCALE_FORMAT_OPTIONS,
      );*/

    }

    if (createdRaw && createdRaw !== '') {
      created = new Date(createdRaw);
      created = Ui.formatDate(created, localization);
      /*
      created = created.toLocaleDateString(
        localization.translate('general.locale'),
        constants.LOCALE_FORMAT_OPTIONS,
      );*/
    }

    if (modifiedRaw && modifiedRaw !== '') {
      modified = new Date(modifiedRaw);
      modified = Ui.formatDate(modified, localization);
      /*
      modified = modified.toLocaleDateString(
        localization.translate('general.locale'),
        constants.LOCALE_FORMAT_OPTIONS,
      );*/
    }

    const orderMapping = {};
    orderMapping[constants.SEGMENT_DELETED] = 0;
    orderMapping[constants.SEGMENT_NEW] = 1;
    orderMapping[constants.SEGMENT_EDITED] = 2;
    orderMapping[constants.SEGMENT_PUBLISHED] = 3;

    const getBadge = () => {
      switch (segment.flag) {
        case constants.SEGMENT_PUBLISHED:
        default:
          if(segment._attributes.warningCode) {
            return `<span class="badge badge-success">${localization.translate('editor.saved')}</span>
                          <br />
                          <span><img alt="" class="warning-sign-segment-list" src="img/warning-sign.svg"></span>`;
          } else {
            return `<span class="badge badge-success">${localization.translate('editor.saved')}</span>`;
          }
        case constants.SEGMENT_NEW:
          return `<span class="badge badge-primary">${localization.translate('editor.new')}</span>
                        <br />
                        <span class="badge badge-warning">${localization.translate('editor.unsaved')}</span>`;
        case constants.SEGMENT_EDITED:
          return `<span class="badge badge-primary">${localization.translate('editor.edited')}</span>
                        <br />
                        <span class="badge badge-warning">${localization.translate('editor.unsaved')}</span>`;
        case constants.SEGMENT_DELETED:
          return `<span class="badge badge-danger">${localization.translate('editor.deleted')}</span>
                        <br />
                        <span class="badge badge-warning">${localization.translate('editor.unsaved')}</span>`;
      }
    };

    const getBadgeType = () => {
      switch (segment.type) {
        case constants.SEGMENT_UNBLOCK:
          return `<span class="badge badge-success">${localization.translate('editor.titles.segment-type-opening')}</span><span class="warning-badge"></span>`;
        case constants.SEGMENT_TURN_RESTRICTION:
          return `<span class="badge badge-success">${localization.translate('editor.titles.segment-type-turn-restriction')}</span>`;
        case constants.SEGMENT_PENALIZE:
          return `<span class="badge badge-warning">${localization.translate('editor.titles.segment-type-penalize')}</span>`;
        case constants.SEGMENT_PRIORITIZE:
          return `<span class="badge badge-primary">${localization.translate('editor.titles.segment-type-prioritize')}</span>`;
        case constants.SEGMENT_TRUCK_ATTRIBUTES:
          return `<span class="badge badge-dark">${localization.translate('editor.titles.segment-type-attributes')}</span>`;
        case constants.SEGMENT_MODIFIED_STREET:
          return `<span class="badge badge-mapchange">${localization.translate('editor.titles.segment-type-modify-street')}</span>`;
        case constants.SEGMENT_TYPE_DELETED_ORIGINAL:
        case constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL:
          return `<span class="badge badge-deleted">${localization.translate('editor.titles.segment-type-delete')}</span>`;
        case constants.SEGMENT_TYPE_DIVIDED_STREET:
        case constants.SEGMENT_TYPE_DISSECTED_STREET:
          return `<span class="badge badge-divided">${localization.translate('editor.titles.segment-type-divided-street')}</span>`;
        case constants.SEGMENT_TYPE_CUT_POINT:
          return `<span class="badge badge-cutpoint">${localization.translate('editor.titles.segment-type-cutpoint')}</span>`;
        case constants.SEGMENT_TYPE_ADDED_MANEUVER:
          if(segment.attributes.detourEditor_editedOriginal) {
            return `<span class="badge badge-modifiedManeuver">${localization.translate('editor.titles.segment-type-modified-maneuver')}</span>`
          } else {
            return `<span class="badge badge-addedManeuver">${localization.translate('editor.titles.segment-type-maneuver')}</span>`
          }
        case constants.SEGMENT_TYPE_MODIFIED_SPEED: {
          const newSpeed = parseInt(segment.attributes.NewSpeed);
          const originalSpeed = parseInt(segment.attributes.detourEditor_originalRoadSpeed);

          if(newSpeed > originalSpeed) {
            return `<span class="badge badge-primary">${localization.translate('editor.titles.segment-type-prioritize')}</span>`;
          } else {
            return `<span class="badge badge-warning">${localization.translate('editor.titles.segment-type-penalize')}</span>`;
          }
        }
        case constants.SEGMENT_TYPE_GEOFENCE: {
          return `<span class="badge badge-geofence">${localization.translate('editor.titles.segment-type-geofence')}</span>`;
        }
        case constants.SEGMENT_CLOSE:
        default:
          return `<span class="badge badge-danger">${localization.translate('editor.titles.segment-type-closure')}</span>`;
      }
    };

    return [
      orderMapping[segment.flag],
      getBadge(),
      segment.id,
      name || `<${i18next.t('general.none')}>`,
      getBadgeType(),
      direction ? directionMap[parseInt(direction, 10)] : '',
      start || '',
      end || '',
      created || '',
      modified || '',
      modifiedBy || '',
      Ui.getButtonsForSegment(segment),
      segment.hash
    ];
  }

  static removeSegmentListRow(segmentRaw) {
    if(window.dataTable) {
      window.dataTable.row(`#segmentList_${segmentRaw.hash}`).remove().draw(false);
    }
  }

  static updateSegmentListRow(segmentRaw, localization) {
    if(window.dataTable) {
      const directionMap = {
        1: '&rarr;',
        2: '&larr;',
        3: '&harr;',
      };

      let data = Ui.getSegmentListRow(segmentRaw, localization, directionMap);
      window.dataTable.row(`#segmentList_${segmentRaw.hash}`).data(data).draw(false);
    }
  }

  static addSegmentListRow(segmentRaw, localization) {
    if(window.dataTable) {
      const directionMap = {
        1: '&rarr;',
        2: '&larr;',
        3: '&harr;',
      };

      let data = Ui.getSegmentListRow(segmentRaw, localization, directionMap);
      window.dataTable.row.add(data).draw(true);
    }
  }

  static toggleEmergencyRoutingInput(show) {
    let emergencyRoutingContainer = $('#emergency-radius');
    let label = $('#emergency-routing-label');
    let tooltip = $('#buttomEmergencyRoutingTitle');
    if(show) {
      emergencyRoutingContainer.removeAttr("hidden");
      label.text(i18next.t("general.enabled"));
      label.data("translation-key", "general.enabled");
      tooltip.data('title-translation-key', "editor.titles.emergency-routing-deactivate")
    } else {
      emergencyRoutingContainer.attr("hidden", true);
      label.text(i18next.t("general.disabled"));
      label.data("translation-key", "general.disabled");
      tooltip.data('title-translation-key', "editor.titles.emergency-routing-activate")
    }
    Ui.translateElements();
  }

  static toggleVehicleProfileInput(show) {
    let label = $('#vehicle-profile-label');
    let container = $('#truck-attributes-settings');
    if(show) {
      container.removeAttr("hidden");
      label.text(i18next.t("general.enabled"));
      label.data("translation-key", "general.enabled")
    } else {
      container.attr("hidden", true);
      label.text(i18next.t("general.disabled"));
      label.data("translation-key", "general.disabled");
    }
  }

  static toggleTruckRoutingInput(show) {
    let label = $('#truck-routing-label');
    if(show) {
      label.text(i18next.t("general.enabled"));
      label.data("translation-key", "general.enabled");
    } else {
      label.text(i18next.t("general.disabled"));
      label.data("translation-key", "general.disabled");
    }
  }

  static toggleIgnoreTurnRestrictionsInput(show) {
    let label = $('#turn-restriction-label');
    if(show) {
      label.text(i18next.t("general.valid"));
      label.data("translation-key", "general.valid");
    } else {
      label.text(i18next.t("general.not-valid"));
      label.data("translation-key", "general.not-valid");
    }
  }

  static toggleIgnoreTurnRestrictionsEmergencyInput(show) {
    let label = $('#turn-restriction-emergency-label');
    if(show) {
      label.text(i18next.t("general.valid"));
      label.data("translation-key", "general.valid");
    } else {
      label.text(i18next.t("general.not-valid"));
      label.data("translation-key", "general.not-valid");
    }
  }

  static toggleSoftrestrictionInput(show) {
    let label = $('#softrestrictions-label');
    if(show) {
      label.text(i18next.t("general.show"));
      label.data("translation-key", "general.show");
    } else {
      label.text(i18next.t("general.hide"));
      label.data("translation-key", "general.hide");
    }
  }

  static toggleHardrestrictionInput(show) {
    let label = $('#hardrestrictions-label');
    if(show) {
      label.text(i18next.t("general.show"));
      label.data("translation-key", "general.show");
    } else {
      label.text(i18next.t("general.hide"));
      label.data("translation-key", "general.hide");
    }
  }

  static checkIfValidNumberInput(keycode) {
    return !(keycode === 69 || keycode === 190 || keycode === 188 || keycode === 189 || keycode === 107 || keycode === 109 || keycode === 187)
  }

  static formatDate(date, localization) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().length === 1 ? "0" + (date.getMonth() + 1).toString() : date.getMonth()+1;
    const day = date.getDate().toString().length === 1 ? "0" + date.getDate().toString() : date.getDate();

    const weekday = date.toLocaleDateString(
      localization.translate('general.locale'),
      {weekday: 'long'}
    );

    const hour = date.getHours().toString().length === 1 ? "0" + date.getHours().toString() : date.getHours();
    const minutes = date.getMinutes().toString().length === 1 ? "0" + date.getMinutes().toString() : date.getMinutes();

    return `${year} ${month} ${day}, ${weekday} ${localization.translate('general.date-at')} ${hour}:${minutes}`;
  }
}


module.exports = Ui;
